export const omittedColumnsByUseCase = {
  aud_dev: ['pixelPageViews', 'revenue', 'profit', 'revenueRoi', 'revenueRoiGoal'],
  sub: ['pixelPageViews', 'revenue', 'profit', 'revenueRoi', 'revenueRoiGoal'],
  brc: ['pixelPageViews', 'revenue', 'profit', 'revenueRoi', 'revenueRoiGoal'],
  ads: ['loyaltyScore', 'newReturningRatio'],
  eco: ['pixelPageViews', 'revenue', 'profit', 'revenueRoi', 'revenueRoiGoal']
};
